import { StdResponse, request } from "@/global/config/request";
import { ProjectFile } from "@/global/interface/project-manage/project-file";
import { AxiosResponse } from "axios"


export function uploadProjectFile(data: ProjectFile, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/project-files/upload`, data, {
        params: params,
    })
}

export function findProjectFiles(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}/project-files`, {
        params: {
            ...params,
        }
    })
}

export function deleteProjectFile(id: number, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/project-files/${id}`, {
        params: {
            ...params,
        }
    })
}

export function deleteProjectFiles(ids: number[], params?: {}): Promise<StdResponse<any>> {
    return request.post(`/project-files/delete-multi`, ids, {
        params: {
            ...params,
        }
    })
}